import React, { useEffect, useState } from "react";
import {
  FaReact,
  FaNodeJs,
  FaDatabase,
  FaMicrochip,
  FaWifi,
  FaCloud,
} from "react-icons/fa";
import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import img1 from "../../assets/image/Navbar/nav-6.jpg";
import { HelmetProvider } from "react-helmet-async";
import Footer from "../Footer/Footer";

const IoTSolutions = () => {
  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);

  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    alert("Enquiry sent successfully!");
    setIsOpenEnquiry(false);
    setFormDataEnquiry({
      name: "",
      email: "",
      phone: "",
      whatsapp: "",
      companyName: "",
      companyService: "",
      serviceType: "",
      country: "",
      message: "",
    });
  };

  const leftServices = [
    {
      icon: "🌐",
      title: "Connected Device Management",
      description:
        "Comprehensive IoT device management platform that enables seamless connectivity, monitoring, and control of thousands of devices from a centralized dashboard with real-time insights.",
    },
    {
      icon: "🛡️",
      title: "24/7 Security & Monitoring",
      description:
        "Advanced security protocols including end-to-end encryption, device authentication, and continuous threat monitoring to protect your IoT ecosystem from vulnerabilities.",
    },
  ];

  const rightServices = [
    {
      icon: "⚡",
      title: "Real-Time Data Processing",
      description:
        "Lightning-fast data analytics and processing capabilities with edge computing support, enabling instant decision-making and automated responses to IoT sensor data.",
    },
    {
      icon: "🚀",
      title: "Scalable Cloud Integration",
      description:
        "Seamlessly integrate with leading cloud platforms (AWS IoT, Azure IoT Hub, Google Cloud IoT) for unlimited scalability and enterprise-grade infrastructure support.",
    },
  ];

  const technologies1 = [
    {
      name: "MQTT Protocol",
      icon: <FaWifi />,
      color: "primary",
      description:
        "Lightweight messaging protocol optimized for IoT devices with minimal bandwidth.",
      extra:
        "Perfect for connecting sensors and devices with low power consumption.",
    },
    {
      name: "Edge Computing",
      icon: <FaMicrochip />,
      color: "success",
      description:
        "Process data closer to the source for faster response times and reduced latency.",
      extra: "Enables real-time analytics and autonomous device operations.",
    },
    {
      name: "Cloud Infrastructure",
      icon: <FaCloud />,
      color: "warning",
      description:
        "Scalable cloud solutions for data storage, processing, and device management.",
      extra: "Supports AWS IoT Core, Azure IoT, and Google Cloud IoT.",
    },
  ];

  const iotProviders = [
    {
      name: "AWS IoT Core",
      features: ["Device Gateway", "Rules Engine", "Device Shadow"],
      speciality: "Enterprise IoT Platform",
      logo: "☁️",
    },
    {
      name: "Azure IoT Hub",
      features: ["Bi-directional", "Device Twins", "Edge Runtime"],
      speciality: "Industrial IoT Solutions",
      logo: "🔷",
    },
    {
      name: "Google Cloud IoT",
      features: ["Global Scale", "AI Integration", "BigQuery"],
      speciality: "Smart Analytics Platform",
      logo: "🌈",
    },
  ];

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <div className="bg-light">
        {/* Enquiry Form Modal */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "90vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#41C1EE",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  IoT Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(90vh - 70px)",
                }}
              >
                <div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    <div>
                      <FaUser
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    <div>
                      <FaEnvelope
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    <div>
                      <FaPhone
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    <div>
                      <FaBuilding
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    <div>
                      <IoMdBuild
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Type</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt Ltd</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">IoT Solution Type</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Smart Home">Smart Home Solutions</option>
                        <option value="Industrial IoT">Industrial IoT</option>
                        <option value="Healthcare IoT">Healthcare IoT</option>
                        <option value="Smart City">Smart City Solutions</option>
                        <option value="Agriculture IoT">Agriculture IoT</option>
                        <option value="Fleet Management">
                          Fleet Management
                        </option>
                        <option value="Custom IoT">
                          Custom IoT Development
                        </option>
                      </select>
                    </div>

                    <div>
                      <FaGlobe
                        style={{
                          color: "#41C1EE",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={3}
                      placeholder="Tell us about your IoT requirements..."
                      style={{ ...inputStyle, resize: "vertical" }}
                    />
                  </div>

                  <div className="mt-3" style={{ textAlign: "center" }}>
                    <button
                      onClick={handleSubmitForm}
                      style={{
                        background: "#41C1EE",
                        color: "white",
                        padding: "12px 30px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Hero Section */}
        <div
          className="position-relative text-white overflow-hidden"
          style={{
            //    minHeight: "50vh",
            //     background: "linear-gradient(135deg, #41C1EE 0%, #004999 100%)"
            backgroundImage: `url(${img1})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="container position-relative py-5">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <nav aria-label="breadcrumb" className="mb-4">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item"
                      aria-current="page"
                    >
                      IoT Solutions
                    </li>
                  </ol>
                </nav>
                <h1 className="display-4 fw-bold mb-3">
                  Internet of Things Solutions
                </h1>
                <p className="fs-5">
                  Connect, Monitor, and Control Your Devices
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Section 1: IoT Integration */}
        <section className="py-5">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <h2 className="display-5 fw-bold mb-4 text-dark">
                  IoT{" "}
                  <span style={{ color: "#41C1EE" }}>Integration Platform</span>
                </h2>
                <p className="fs-6 mb-4 text-dark">
                  Transform your business with our comprehensive IoT solutions.
                  Connect devices, collect data, and gain actionable insights
                  through our powerful platform that scales with your needs.
                </p>
                <div className="mb-4">
                  <div className="d-flex align-items-center mb-3">
                    <span className="text-success me-2">✓</span>
                    <span className="fw-medium text-dark">
                      Multi-Protocol Support (MQTT, CoAP, HTTP)
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <span className="text-success me-2">✓</span>
                    <span className="fw-medium text-dark">
                      Real-Time Device Monitoring
                    </span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <span className="text-success me-2">✓</span>
                    <span className="fw-medium text-dark">
                      Enterprise-Grade Security
                    </span>
                  </div>
                </div>
                <button
                  className="btn text-white fw-semibold px-4 py-2"
                  style={{ background: "#41C1EE" }}
                  onClick={() => setIsOpenEnquiry(true)}
                >
                  Get Started
                </button>
              </div>
              <div className="col-lg-5 text-center">
                <div style={{ fontSize: "200px" }}>🌐</div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 2: Technologies */}
        <section className="py-5 bg-light">
          <div className="container">
            <div className="text-center mb-5">
              <button
                className="btn border fw-semibold bg-transparent px-3 py-2 rounded-pill"
                style={{ color: "#41C1EE", borderColor: "#41C1EE" }}
              >
                CUTTING-EDGE TECHNOLOGIES
              </button>
              <h2 className="display-5 fw-bold mt-3 mb-3">
                Built on{" "}
                <span style={{ color: "#41C1EE" }}>Modern IoT Stack</span>
              </h2>
              <p className="fs-6 mx-auto" style={{ maxWidth: "700px" }}>
                Leveraging industry-leading technologies for reliable, scalable,
                and secure IoT deployments
              </p>
            </div>

            <div className="row g-4 mb-5">
              {technologies1.map((tech, index) => (
                <div key={index} className="col-lg-4">
                  <div
                    className="card h-100 border-0 shadow-sm"
                    style={{
                      borderRadius: "20px",
                      transition: "transform 0.3s ease",
                      transform:
                        hoveredCard === `tech-${index}`
                          ? "translateY(-10px)"
                          : "translateY(0)",
                    }}
                    onMouseEnter={() => setHoveredCard(`tech-${index}`)}
                    onMouseLeave={() => setHoveredCard(null)}
                  >
                    <div className="card-body p-4 text-center">
                      <div
                        className="mb-3"
                        style={{ fontSize: "60px", color: "#41C1EE" }}
                      >
                        {tech.icon}
                      </div>
                      <h4 className="fw-bold mb-3" style={{ color: "#41C1EE" }}>
                        {tech.name}
                      </h4>
                      <p className="mb-3">{tech.description}</p>
                      <p className="text-muted small">{tech.extra}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Why Choose Section */}
            <div className="bg-white rounded-4 p-5 shadow-sm">
              <div className="text-center mb-5">
                <h3 className="fw-bold mb-3" style={{ color: "#41C1EE" }}>
                  Why Choose Our IoT Platform?
                </h3>
                <p className="mb-0">
                  Enterprise-grade solutions for businesses of all sizes
                </p>
              </div>

              <div className="row g-4">
                <div className="col-lg-3 col-md-6 text-center">
                  <div className="p-4">
                    <div className="fs-1 mb-3">⚡</div>
                    <h5 className="fw-bold mb-2">Low Latency</h5>
                    <p className="small mb-0">Sub-millisecond response times</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 text-center">
                  <div className="p-4">
                    <div className="fs-1 mb-3">🔒</div>
                    <h5 className="fw-bold mb-2">Secure by Design</h5>
                    <p className="small mb-0">End-to-end encryption</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 text-center">
                  <div className="p-4">
                    <div className="fs-1 mb-3">📈</div>
                    <h5 className="fw-bold mb-2">Infinite Scale</h5>
                    <p className="small mb-0">Millions of connected devices</p>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6 text-center">
                  <div className="p-4">
                    <div className="fs-1 mb-3">🛠️</div>
                    <h5 className="fw-bold mb-2">Easy Integration</h5>
                    <p className="small mb-0">Plug-and-play SDKs</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Section 3: Features */}
        <section className="py-5">
          <div className="container">
            <div className="text-center mb-5">
              <button
                className="btn border fw-semibold bg-transparent px-3 py-2 rounded-pill"
                style={{ color: "#41C1EE", borderColor: "#41C1EE" }}
              >
                PLATFORM FEATURES
              </button>
              <h2 className="display-6 fw-bold mb-3">
                Comprehensive{" "}
                <span style={{ color: "#41C1EE" }}>IoT Capabilities</span>
              </h2>
              <p className="fs-6 mx-auto" style={{ maxWidth: "700px" }}>
                Everything you need to build, deploy, and manage IoT solutions
                at scale
              </p>
            </div>

            <div className="row align-items-center">
              <div className="col-lg-4">
                {leftServices.map((service, index) => (
                  <div key={index} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: "60px",
                          height: "60px",
                          background: "#41C1EE",
                          flexShrink: 0,
                        }}
                      >
                        <span style={{ fontSize: "28px", color: "#ffffff" }}>
                          {service.icon}
                        </span>
                      </div>
                      <div>
                        <h5 className="fw-bold mb-2">{service.title}</h5>
                        <p className="text-muted mb-0">{service.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="col-lg-4 text-center">
                <div style={{ fontSize: "250px" }}>📡</div>
              </div>

              <div className="col-lg-4">
                {rightServices.map((service, index) => (
                  <div key={index} className="mb-4">
                    <div className="d-flex align-items-start">
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center me-3 order-lg-2"
                        style={{
                          width: "60px",
                          height: "60px",
                          background: "#41C1EE",
                          flexShrink: 0,
                        }}
                      >
                        <span style={{ fontSize: "28px", color: "#ffffff" }}>
                          {service.icon}
                        </span>
                      </div>
                      <div className="text-lg-end order-lg-1">
                        <h5 className="fw-bold mb-2">{service.title}</h5>
                        <p className="text-muted mb-0">{service.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Section 4: IoT Platforms */}
        <section className="py-5 bg-light">
          <div className="container">
            <div className="text-center mb-5">
              <button
                className="btn border fw-semibold bg-transparent px-3 py-2 rounded-pill"
                style={{ color: "#41C1EE", borderColor: "#41C1EE" }}
              >
                CLOUD PLATFORMS
              </button>
              <h2 className="display-6 fw-bold mb-3">
                Integrated{" "}
                <span style={{ color: "#41C1EE" }}>Cloud Solutions</span>
              </h2>
              <p className="fs-6">
                Seamlessly connect with leading IoT cloud platforms
              </p>
            </div>

            <div className="row g-4">
              {iotProviders.map((provider, index) => (
                <div key={index} className="col-lg-4">
                  <div
                    className="card border-0 h-100 shadow-sm"
                    style={{ borderRadius: "16px" }}
                  >
                    <div className="card-body p-4 text-center">
                      <div className="mb-3" style={{ fontSize: "80px" }}>
                        {provider.logo}
                      </div>
                      <h4 className="fw-bold mb-2">{provider.name}</h4>
                      <p
                        className="fw-semibold mb-4"
                        style={{ color: "#41C1EE" }}
                      >
                        {provider.speciality}
                      </p>
                      <div className="mb-4">
                        {provider.features.map((feature, idx) => (
                          <span
                            key={idx}
                            className="badge me-2 mb-2 px-3 py-2"
                            style={{ background: "#e6f2ff", color: "#41C1EE" }}
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                      <button
                        className="btn text-white fw-semibold px-4 py-2"
                        style={{ background: "#41C1EE" }}
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Benefits Section */}
            <div className="mt-5 bg-white rounded-4 p-5">
              <div className="text-center mb-5">
                <h3 className="fw-bold mb-3" style={{ color: "#41C1EE" }}>
                  Why Cloud IoT Integration?
                </h3>
                <p className="mb-0">
                  Unlock the full potential of your IoT ecosystem
                </p>
              </div>

              <div className="row g-4">
                <div className="col-md-4 text-center">
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle text-white"
                      style={{
                        width: "60px",
                        height: "60px",
                        background: "#41C1EE",
                      }}
                    >
                      <span className="fs-4">🌍</span>
                    </div>
                  </div>
                  <h5 className="fw-bold mb-3">Global Reach</h5>
                  <p className="mb-0">
                    Deploy IoT solutions worldwide with multi-region support
                  </p>
                </div>

                <div className="col-md-4 text-center">
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle text-white"
                      style={{
                        width: "60px",
                        height: "60px",
                        background: "#41C1EE",
                      }}
                    >
                      <span className="fs-4">⚡</span>
                    </div>
                  </div>
                  <h5 className="fw-bold mb-3">Real-Time Processing</h5>
                  <p className="mb-0">
                    Instant data processing and analytics at the edge
                  </p>
                </div>

                <div className="col-md-4 text-center">
                  <div className="mb-3">
                    <div
                      className="d-inline-flex align-items-center justify-content-center rounded-circle text-white"
                      style={{
                        width: "60px",
                        height: "60px",
                        background: "#41C1EE",
                      }}
                    >
                      <span className="fs-4">💻</span>
                    </div>
                  </div>
                  <h5 className="fw-bold mb-3">Developer Friendly</h5>
                  <p className="mb-0">
                    Comprehensive APIs and SDKs for rapid development
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </HelmetProvider>
  );
};

export default IoTSolutions;
